// apps/client/src/apps/analytics/track.ts

type GtagParams = Record<string, unknown>;

export function safeGtagEvent(eventName: string, params?: GtagParams) {
  // English comments per your preference:
  // Guard: GA script might not be loaded yet, or blocked by consent/adblock.
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;

  window.gtag("event", eventName, params);
}